import {useTranslation} from "react-i18next";
import {useCallback, useEffect, useState} from "react";
import {useI18nState} from "./useI18nState";
import {FetchOptionType, IOptionType} from "../types/common";
import {fetchItemGroups, fetchItemMPOptions, fetchManufacturers} from "../utils/storageUtil";
import {ExtractedItem} from "../utils/manualFinderUtils";
import {Amplify} from "aws-amplify";
import aws_config from "../modified_aws-export";

Amplify.configure(aws_config);

export const useLoadOptions = (fetchKey?: string[]) => {
    const {t} = useTranslation();
    const {selectedLanguage} = useI18nState();
    const [statusOptions, setStatusOptions] = useState<Record<string, { label: string; color: string }>>({});
    const [presetOptions, setPresetOptions] = useState<Record<number, { label: string; tooltip: string }>>({});
    const [manufacturerOptions, setManufacturerOptions] = useState<IOptionType[]>([])
    const [itemGroupOptions, setItemGroupOptions] = useState<IOptionType[]>([])
    const [extractedTypeOptions, setExtractedTypeOptions] = useState<IOptionType[]>([])
    const [itemMPOptions, setItemMPOptions] = useState<IOptionType[]>([])

    const initializeOptions = useCallback(async () => {
        if (fetchKey?.includes(FetchOptionType.Manufacturer)) {
            setManufacturerOptions(await fetchManufacturers());
        }
        if (fetchKey?.includes(FetchOptionType.ItemGroups)) {
            setItemGroupOptions(await fetchItemGroups(selectedLanguage));
        }
        if (fetchKey?.includes(FetchOptionType.ItemMPOptions)) {
            setItemMPOptions(await fetchItemMPOptions());
        }
    }, [selectedLanguage, t]);

    useEffect(() => {
        setExtractedTypeOptions([
            {value: ExtractedItem.SpecialTools, label: t('Sidebar.SpecialTools')},
            {value: ExtractedItem.ImagesManual, label: t('Sidebar.ImagesManualSelection')},
            {value: ExtractedItem.ImagesAutomatic, label: t('Sidebar.ImagesAutomaticSelection')}
        ])
        setPresetOptions({
            0: {
                label: t('Vectorization.Preset.SmallCurvesTitle'),
                tooltip: t('Vectorization.Preset.SmallCurvesTooltip')
            },
            1: {
                label: t('Vectorization.Preset.StraightLinesTitle'),
                tooltip: t('Vectorization.Preset.StraightLinesTooltip')
            },
            2: {
                label: t('Vectorization.Preset.BigCurvesTitle'),
                tooltip: t('Vectorization.Preset.BigCurvesTooltip')
            },
            3: {
                label: t('Vectorization.Preset.SmallCurvesLessChangeTitle'),
                tooltip: t('Vectorization.Preset.SmallCurvesLessChangeTooltip')
            },
            4: {
                label: t('Vectorization.Preset.StraightLinesLessChangeTitle'),
                tooltip: t('Vectorization.Preset.StraightLinesLessChangeTooltip')
            },
        });
        setStatusOptions({
            completed: {
                label: t("Vectorization.Status.Completed"),
                color: "success",
            },
            pending: {
                label: t("Vectorization.Status.Pending"),
                color: "warning",
            },
            processing: {
                label: t("Vectorization.Status.Pending"),
                color: "warning",
            },
            failed: {
                label: t("Vectorization.Status.Failed"),
                color: "danger",
            },
        });
        initializeOptions();
    }, [initializeOptions, selectedLanguage, t]);

    return {presetOptions, statusOptions, itemGroupOptions, manufacturerOptions, extractedTypeOptions, itemMPOptions}
}